export enum PageType {
  View = 1,
  Edit = 2,
  Audit = 3,
  Quote = 4,
}

export enum KnowledgePageType {
  View = 1,
  Edit = 2,
  Audit = 3,
}

export enum DrugNameType {
  TradeName = '商品名（trade name）',
  Ingredient = '成分（Ingredient）'
}

export const drugNameTypes = [
  // 商品名
  { value: 1, label: DrugNameType.TradeName },
  // 成分名
  { value: 2, label: DrugNameType.Ingredient }
]

